import { gql } from '@apollo/client';

import { MatchupFields, MatchupVoteResultsFields } from './fragments';

export const GET_STREAM_MATCHUP_INVITES = gql`
  query GetStreamMatchupInvites($streamId: String!) {
    getStreamMatchupInvites(streamId: $streamId) {
      matchupId
      corner
      name
      invitedEmail
      inviteToken
    }
  }
`;

export const GET_STREAM_MATCHUPS = gql`
  query GetStreamMatchups($streamId: String!) {
    getStreamMatchups(streamId: $streamId) {
      ...MatchupFields
    }
  }
  ${MatchupFields}
`;

export const GET_STREAM_VOTE_RESULTS = gql`
  query GetStreamVoteResults($streamId: String!) {
    getStreamVoteResults(streamId: $streamId) {
      ...MatchupVoteResultsFields
    }
  }
  ${MatchupVoteResultsFields}
`;

// Polls a share-pick (image-generation) job; imageURL is set once completed.
export const CHECK_GENERATION_JOB_STATUS = gql`
  query CheckGenerationJobStatus($id: String!) {
    checkGenerationJobStatus(id: $id) {
      id
      status
      imageURL
    }
  }
`;
